import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AncillaryContent } from '../../models';

@Component({
  selector: 'idp-my-trip-ancillary',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule],
  templateUrl: './ancillary-link.component.html',
  styleUrls: ['./ancillary-link.component.scss']
})
export class MyTripAncillaryComponent {
  @Input()
  content!: AncillaryContent | null;

  @Input()
  displayLink!: boolean | null;

  @Output() displayFindTrip: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() displayAllTrips = new EventEmitter();
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();
  displaySearchComponent = (): void => this.displayFindTrip.emit(true);

  viewAllTrips = (): void => this.displayAllTrips.emit();
}
